import {normalizeSignaturesRpcData} from './getSignatureForAddress.js';
import {getLimiter} from './../instance.js';
/**
 * Fetches signatures for a given address.
 *
 * @param address - The address to fetch signatures for.
 * @param until - Optional parameter to fetch signatures until a certain point.
 * @param limit - The maximum number of signatures to fetch.
 * @returns An array of signatures.
 */
export async function fetchSignaturesForAddress(
    address:any,
    until:any|null=null,
    limit:any|null=null,
    normalize:boolean | null=null
) {
    if (!limit){
        limit = 1000
    }
    const method = 'getSignaturesForAddress';
    const params = [address, { until, limit }];
    const response = await getLimiter().fetchRpc(method,params)
    if (normalize == true){
        return normalizeSignaturesRpcData(address, response as any);
    } 
    return response
}

